import { useEffect, useState } from "react";
import { TaxableBase } from "../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxableBase";
import { BasicButton } from "../theme/Component/BasicButton";
import { CardTaps } from "../theme/Component/CardTaps";
import { PrintJson } from "../theme/Component/PrintJson";

interface Props {
    data: any;
    event: any;
}
export const TaxBaseEditor = ({ data, event }: Props) => {

    const [invoice, setInvoice] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    useEffect(() => {
        setBean({ ...data });
        let x = {};
        try {
            x = JSON.parse(localStorage.getItem("SimulatorInvoice")) || {}
        } catch (error) {
            console.error(error)
        }
        setInvoice(x);
    }, [data])

    let taps = [
        { id: 0, name: 'Seleccionar Base', disable: false },
        { id: 1, name: 'Escribir Base', disable: false },
    ];

    const [indexTap, setIndexTap] = useState(0);

    const updateClick = (value: any) => {
        let uBean = bean;
        uBean.TaxBase = value;
        console.log(uBean)
        event(uBean);
    }

    const updateRow = (values: any) => {
        let uBean = { ...bean, OBIDDocument: values.OBIDDocument, TaxBase: values.TaxableAmount, BudgetID: values.BudgetID, IDBudgetResource: values.IDBudgetResource, IDBudgetSource: values.IDBudgetSource };
        console.log(uBean);
        event(uBean);
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {invoice.IDUBLInvoice ?
                    <>
                        {invoice.PaymentType === 17 &&
                            <TaxableBase invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                        }
                        {invoice.PaymentType === 18 &&
                            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                                {indexTap === 0 &&
                                    <TaxableBase invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                                }
                                {indexTap === 1 &&
                                    <div className="row">
                                        <div className="col-12">
                                            <label >Base</label>
                                            <input type="text" className="form-control" value={bean.TaxableBase} onChange={(e) => { setBean({ ...bean, "TaxBase": parseInt(e.target.value) }) }} />
                                        </div>
                                        <div className="col-md-12 mt-4">
                                            <BasicButton icon="" eventClick={() => { event(bean) }}>Guardar</BasicButton>
                                        </div>
                                    </div>
                                }
                            </CardTaps>
                        }
                        {!invoice.PaymentType &&
                            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                                {indexTap === 0 &&
                                    <TaxableBase invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                                }
                                {indexTap === 1 &&
                                    <div className="row">
                                        <div className="col-12">
                                            <label >Base</label>
                                            <input type="text" className="form-control" value={bean.TaxableBase} onChange={(e) => { setBean({ ...bean, "TaxBase": parseInt(e.target.value) }) }} />
                                        </div>
                                        <div className="col-md-12 mt-4">
                                            <BasicButton icon="" eventClick={() => { event(bean) }}>Guardar</BasicButton>
                                        </div>
                                    </div>
                                }
                            </CardTaps>
                        }
                    </>
                    :
                    <div className="row">
                        <div className="col-12">
                            <label >
                                Base
                            </label>
                        </div>
                        <div className="col-12">
                            <input type="text" className="form-control" value={bean.TaxableBase} onChange={(e) => { setBean({ ...bean, "TaxableBase": parseInt(e.target.value) }) }} />
                        </div>
                        <div className="col-md-12">
                            <BasicButton icon="" eventClick={() => { event(bean); console.log(bean) }}>Guardar</BasicButton>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}